// Generated by CoffeeScript 2.7.0
var MessageNavActions;

export default MessageNavActions = {
  beforeAction: function(action) {
    this.__initPopover();
    return this.__initPreviewBtn();
  },
  __initPreviewBtn: function() {
    var messageGID;
    if (!this.getVars().messageGID) {
      return;
    }
    messageGID = new Skylark.Libs.GlobalID(this.getVars().messageGID);
    return document.body.proxy('click', '.js_preview', function() {
      return window.open(`/admin/${messageGID.toPath()}/preview`);
    });
  },
  __initPopover: function() {
    this.____initSharePopover();
    this.____initMoreSettingsPopover();
    return this.____initNavMenuPopover();
  },
  ____initSharePopover: function() {
    return new Skylark.Elements.SharePopover(DomMaster.find('.share-popover'));
  },
  ____initMoreSettingsPopover: function() {
    return new Skylark.Elements.MoreSettingsPopover(DomMaster.find('.more-settings-popover'));
  },
  ____initNavMenuPopover: function() {
    // 获取指定dom，实例化一个popover并返回
    return new Skylark.Elements.Popover(DomMaster.find('.nav-menu-popover'), {
      size: 'larger',
      type: 'prompt'
    });
  }
};
